const mainThemeColor = '#f22627'
const mainThemeColorLight = '#f22627'
const dimBackgroundColor = 'rgba(0,0,0,0.8)'
export const ConfigImport = {
  appName: 'Spec Message',
  appDisplayName: 'Spec Tim',
  version: '0.8',
  build: '132',
  organization: 'Spexco',
  theme: {
    default: {
      loginPage: {
        topBarColor: mainThemeColor,
        loginBtnColor: mainThemeColor,
        colorTextColor: mainThemeColor,
        organizationLogo: '/theme/spectim/logo.png'
      },
      homePage: {
        topBarColor: mainThemeColor,
        bottomBorderColor: mainThemeColorLight,
        loadingGif: 'url(/theme/spectim/loading.gif)',
        loadingBackgroundColor: '#FFFFFF'
      },
      sideMenu: {
        topBarColor: mainThemeColorLight,
        fontColor: mainThemeColorLight,
        buttonColor: mainThemeColorLight
      },
      previewPage: {
        topBarColor: mainThemeColorLight,
        backgroundColor: dimBackgroundColor,
        bottomBorderColor: mainThemeColorLight,
        buttonColor: mainThemeColorLight,
        progressBarColor: mainThemeColorLight
      },
      emojiPage: {
        tabSelectedColor: mainThemeColorLight
      },
      messageContainer: {
        messageBalloon: {
          hasMoreTextLinkColor: '#1976D2',
          incomingMessageBgColor: '#CCCCCC',
          outgoingMessageBgColor: '#fde9e9',
          addToGroupColor: '#00DDDD'
        }
      },
      common: {
        coloredTextColor: mainThemeColor
      }
    }
  },

  // serviceURLs: {
  //   loginURL: 'https://spec.spexco.com:3410/lb',
  //   uploadURL: 'https://spec.spexco.com:3410/ufeb',
  //   uploadURL2: 'https://spec.spexco.com:3410',
  //   authURL: 'https://spec.spexco.com:3410/Auth'
  // },
  // socketInfo: {
  //   connection: null,
  //   qrConnection: null,
  //   baseUrl: 'wss://spec.spexco.com:3411',
  //   qrUrl: 'wss://spec.spexco.com:3412',
  //   browserUuid: '',
  //   source: 'browser',
  //   url: 'ws://192.168.1.12:3411?userid=mustafa&sec=f6d425e830e85c74d89ba0114dd93a36&source=browser',
  //   protocol: 'specMessage',
  //   reconnectTimer: 1,
  //   reconnectProgress: 2,
  //   maxReconnectTimer: 30
  // },
  sinfo: {
    ien: true // isEncrypted
  }
}
